'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'sunrise';
var width = 576;
var height = 512;
var aliases = [127749];
var unicode = 'f766';
var svgPathData = 'M520.4 464c13.3 0 24 10.7 24 24s-10.7 24-24 24l-464 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l464 0zM375.1 200.8c6.8-5 15.7-6.1 23.5-2.9s13.3 10.3 14.6 18.7L429 323.4 535.9 339.2c8.3 1.2 15.4 6.8 18.6 14.6s2.1 16.7-2.9 23.5l-28.8 38.7-98.7 0c-.8-2.4-1.7-4.8-2.7-7.1-30.4-73.5-114.7-108.4-188.1-77.9-39.3 16.3-67.5 47.9-80.7 85.1L54 416 25.2 377.3c-5-6.8-6.1-15.7-2.9-23.5S32.6 340.5 41 339.2l106.8-15.8 15.8-106.8 .7-3c2-7 7.1-12.8 13.9-15.6 7.8-3.2 16.7-2.1 23.5 2.9l86.7 64.3 86.7-64.3zM251.7 375.3c45.1-18.7 96.2-.5 119.9 40.7l-166.2 0c10.2-17.7 26-32.3 46.3-40.7zM273.3-10.6c9.4-7.7 23.3-7.1 32.1 1.7l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 102.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64 1.8-1.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunrise = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;